module.exports = __webpack_public_path__ + "static/media/img_42.5f7bb5de.png";